<template>
  <view-selector
    :view="view"
    :current-date="currentDate"
    @update:view="setView"
    @update:currentDate="setCurrentDate"
    @startDate="setStartDate"
    @endDate="setEndDate"
  />
</template>

<script>
  import ViewSelector from '@/views/dashboard/components/ViewSelector'
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: 'ViewXSelector',
    components: {
      ViewSelector,
    },
    computed: {
      ...mapState('records', ['view', 'currentDate', 'startDate', 'endDate', 'selectedMembersId']),
    },
    methods: {
      ...mapMutations({
        setView: 'records/setView',
        setStartDate: 'records/setStartDate',
        setEndDate: 'records/setEndDate',
        setCurrentDate: 'records/setCurrentDate',
        setSelectedMembersId: 'records/setSelectedMembersId',
      }),
    },
  }
</script>

<style scoped>

</style>
